import React from 'react';
import { Modal, FormGroup, ControlLabel, FormControl, Button, Form, Col, Checkbox } from 'react-bootstrap';
import PropTypes from 'prop-types';

export const AddSkillDetailsModal = ({show, hide, scene, data, updated, submitted}) => {
    return (
        <Modal show={show} onHide={hide}>
            <Modal.Header closeButton>
                <Modal.Title>Add New Skill Details to {scene}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form horizontal onSubmit={submitted}>
                    <h4>Source</h4>
                    {formTextField('Dataset', 'The dataset number for the skill to be added to', updated, data.datasetValidation)}
                    {formTextField('Skill Name', 'The name of an existing skill', updated, data.skillNameValidation)}
                    {formCheckbox('Scores', updated)}

                    <Button type="submit" bsStyle="success" block disabled={!data.formValid}>Create</Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

const formTextField = (label, placeholder, onChange, validation) => {
    return (
        <FormGroup controlId={`formHorizontal${label}`} validationState={validation}>
            <Col componentClass={ControlLabel} sm={3}>{label}</Col>
            <Col sm={9}>
                <FormControl type='text' name={label} placeholder={placeholder} onChange={onChange} />
                <FormControl.Feedback />
            </Col>
        </FormGroup>
    );
};

//Use this in the future if Dataset or Skill Name becomes a dropdown menu....
const formOptionsField = (label,  options, onChange, validation) => {
    return (
        <FormGroup controlId={`formHorizontal${label}`} validationState={validation}>
            <Col componentClass={ControlLabel} sm={3}>{label}</Col>
            <Col sm={9}>
                <FormControl componentClass='select' name={label} onChange={onChange} defaultValue=''>
                    <option value='' disabled/>
                    {Object.entries(options).map(formOption)}
                </FormControl>
                <FormControl.Feedback />
            </Col>
        </FormGroup>
    );
};

const formOption = kvp => {
    return (<option key={kvp[0]} value={kvp[0]}>{kvp[1]}</option>);
};

const formCheckbox = (label, onChange) => {
    return (
        <FormGroup controlId={`formHorizontal${label}`}>
            <Col componentClass={ControlLabel} sm={3}>{label}</Col>
            <Col sm={9}>
                <Checkbox name={label} onChange={onChange}></Checkbox>
            </Col>
        </FormGroup>   
    );
}

AddSkillDetailsModal.propTypes = {
    show:       PropTypes.bool.isRequired,
    hide:       PropTypes.func.isRequired,
    scene:      PropTypes.string.isRequired,
    data:       PropTypes.object.isRequired,
    updated:    PropTypes.func.isRequired,
    submitted:  PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/addSkillDetailsModal/AddSkillDetailsModal.js